import { TextField } from "@mui/material";

import { Tooltip } from "components/Tooltip";
import {
  textFieldStyle,
  inputPropStyles,
  outlinedStyles,
} from "components/formFields/lineItemFieldStyle";

/**
 * @name    makeLineItemRenderInput
 *
 * @summary Returns a renderInput function suitable for passing to
 *          DynamicAutocompleteField (or MUI Autocomplete) in a line-item
 *          context.  The returned function renders an outlined TextField with
 *          standard line-item styles wrapped in a Tooltip that shows the
 *          currently selected value's name.
 *
 * @param   value  {object|null}  the currently selected option object;
 *                                used to populate the Tooltip title
 * @returns {function}  renderInput(params) => JSX
 */
export function makeLineItemRenderInput(value) {
  return function renderInput(params) {
    const textfield = (
      <TextField
        {...params}
        variant="outlined"
        margin="dense"
        fullWidth
        sx={{ ...textFieldStyle, ...outlinedStyles }}
        InputProps={{ ...params.InputProps, sx: inputPropStyles }}
        InputLabelProps={{ shrink: true }}
        SelectProps={{ MenuProps: { disableScrollLock: true } }}
      />
    );
    return (
      <Tooltip title={value?.name ?? ""} placement="top-start">
        {textfield}
      </Tooltip>
    );
  };
}
